import { getUserFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

export async function fetchOpeningApplicantMeta({ applicantId }) {
    try {
        const query = {
            fields: [
                "id",
                getUserFields("employee"),
                "experience",
                "description",
                "resume_url",
                "is_selected",
            ],
        };

        const data = await getItemFromCollection("opening_applicants", applicantId, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}